// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import type { Node } from 'react';
import analytics from './analytics';

type Props = {
  name: string;
  identifier?: string | number;
  children: Node;
};

export default class Page extends Component<Props> {

  constructor(props: Props) {
    super(props);
    analytics.pageView(props.name);
    // console.log('constructed props', props.name);
  }

  componentDidUpdate(prevProps: Props) {
    const prevId = prevProps.identifier;
    const currentId = this.props.identifier;
    // console.log('** did update', prevProps.name, this.props.name);
    if (prevProps.name !== this.props.name || prevId !== currentId) {
      // console.log('pageView', this.props.name);
      analytics.pageView(this.props.name);
    }
  }

  componentDidMount() {
    const { name } = this.props;
    // console.log('did mount', name);
  }

  render() {
    // console.log('** render', this.props.name);
    return this.props.children;
  }
}

Page.propTypes = {
  name: PropTypes.string.isRequired,
  identifier: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};



// WEBPACK FOOTER //
// ./src/Page.jsx